"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _acsScWebPlatformApi = require("@adsk/acs-sc-web-platform-api");
const getRequestConfig = () => {
  return {
    region: (0, _acsScWebPlatformApi.getRegion)(),
    env: getReportsEnv(),
    getAccessToken: async () => {
      const {
        accessToken
      } = await (0, _acsScWebPlatformApi.getCurrentToken)();
      return accessToken;
    }
  };
};
const getReportsEnv = () => {
  const accEnv = (0, _acsScWebPlatformApi.getEnv)();
  return {
    QA: 'qa',
    STAGING: 'stg',
    PRODUCTION: 'prod'
  }[accEnv?.toUpperCase()];
};
var _default = exports.default = getRequestConfig;